"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var SimpleDate =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(SimpleDate, _PureComponent);

  function SimpleDate() {
    (0, _classCallCheck2["default"])(this, SimpleDate);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SimpleDate).apply(this, arguments));
  }

  (0, _createClass2["default"])(SimpleDate, [{
    key: "render",
    value: function render() {
      var date = this.props.date;
      return _react["default"].createElement("span", null, new Date(date).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      }));
    }
  }]);
  return SimpleDate;
}(_react.PureComponent);

exports["default"] = SimpleDate;
SimpleDate.propTypes = {
  date: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};